import React, { useState, useEffect } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

import userTokenService from 'common/services/security/userTokenService';
import { forEach } from 'lodash';
import { UnableToLoadContentTemplate } from 'features/analyses/common/UnableToLoadContent/UnableToLoadContent';

const domParseReplace = (
  cssSelector,
  stringifyUnableToLoadContent,
  richTextData
) => {
  const content = new DOMParser().parseFromString(richTextData, 'text/html');
  const el = content.getElementsByClassName(cssSelector);
  forEach(el, (element) => {
    element.innerHTML = stringifyUnableToLoadContent;
  });
  return content.documentElement.innerHTML;
};

// todo -> this fix is only temporary until BE dont have time to fix error content
export const useJunctionErrorMapping = (richTextData, projectId) => {
  const isPwcUser = userTokenService.isUserInternal();
  const [mappedRichTextData, setMappedRichTextData] = useState(richTextData);

  const stringifyUnableToLoadContent = renderToStaticMarkup(
    <UnableToLoadContentTemplate
      projectId={projectId}
      placeId="content-error-junctionErrorMapping"
      isPwcUser={Boolean(isPwcUser)}
    />
  );

  useEffect(() => {
    const withUnableToLoadContent = domParseReplace(
      'library-item-error',
      stringifyUnableToLoadContent,
      richTextData
    );
    setMappedRichTextData(withUnableToLoadContent);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return mappedRichTextData;
};
